import { HTMLProps, useState } from 'react';

import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core';
import { TabContext } from '@material-ui/lab';

import classNames from 'classnames';

import { ActivityItemContext } from './ActivityItemContext';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      padding: 0,
      paddingLeft: 'var(--encore-spacing-tighter-5)',
      backgroundColor: theme.palette.action.active,
      borderRadius: theme.shape.borderRadius,
      marginLeft: 'var(--encore-spacing-looser)',
    },
  });

export interface RootProps
  extends HTMLProps<HTMLDivElement>,
    WithStyles<typeof styles> {
  defaultTab?: string;
}

const Root = ({
  children,
  classes,
  className,
  defaultTab = 'overview',
  ...rest
}: RootProps) => {
  const [tab, setTab] = useState<string>(defaultTab);

  return (
    <TabContext value={tab}>
      <ActivityItemContext.Provider value={{ tab, setTab }}>
        <div className={classNames(classes.root, className)} {...rest}>
          {children}
        </div>
      </ActivityItemContext.Provider>
    </TabContext>
  );
};

export default withStyles(styles)(Root);
